import { defineComponent } from 'vue';
import { QCircularProgress } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

export default defineComponent({
    name: 'cc-progress-circle-dsgn',
    mixins: [BaseComponentMixin],
    components: { QCircularProgress },
    computed: {
        containerStyle() {
            return {
                ...utils.getStyleHints(this.controlData?.StyleHints),
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                overflow: 'hidden',
            };
        },
        color() {
            if (this.controlData?.Color && !this.controlData.Color.includes('{'))
                return this.controlData.Color;
            return 'orange';
        },
        /** 0–100 for QCircularProgress (default min/max) — matches runtime */
        progressValue() {
            let v = 35;
            if (this.controlData?.ValueExpression)
                v = utils.helpers.tryParseInt(this.controlData.ValueExpression, 35);
            return Math.min(100, Math.max(0, Number(v) || 0));
        },
        /** thickness 0–1 (runtime); designer ints > 1 treated as percent of bar */
        thickness() {
            if (!this.controlData?.WidthExpression)
                return 0.2;
            const n = utils.helpers.tryParseInt(this.controlData.WidthExpression, 20);
            if (n >= 0 && n <= 1)
                return n;
            return Math.min(1, Math.max(0.05, n / 100));
        },
        /** Pixel size string — runtime defaults ~80px */
        size() {
            let px = 80;
            if (this.controlData?.SizeExpression)
                px = utils.helpers.tryParseInt(this.controlData.SizeExpression, 80);
            return `${px}px`;
        },
        angle() {
            if (this.controlData?.RotateExpression)
                return utils.helpers.tryParseInt(this.controlData.RotateExpression, 0);
            return 0;
        },
    },
    props: {
    },
    render() {
        try {
            const hasContent = !!this.controlData.Content;
            const contentSlot = hasContent
                ? { default: () => <span>{this.controlData.Content}</span> }
                : undefined;

            return (
                <div
                    style={this.containerStyle}
                    class={{
                        'c-ProgressCircle': true,
                        'c-ProgressCircleDsgn': true,
                        [`c-name-${this.name || 'unnamed'}`]: true,
                        'designer-container': true,
                        selected: this.selected$,
                    }}
                    onClick={(e) => this.handleClick(e)}>
                    <div class={{ 'designer-container-hovering': true, 'designer-container-selected-clickthrough': this.selected$ }} />
                    <QCircularProgress
                        style={{ width: '100%', height: '100%' }}
                        value={this.progressValue}
                        size={this.size}
                        thickness={this.thickness}
                        angle={this.angle}
                        color={this.color}
                        indeterminate={this.controlData.Indeterminate}
                        showValue={hasContent}
                        {...(contentSlot ? { vSlots: contentSlot } : {})}
                    />
                </div>
            );
        }
        catch (e) {
            utils.error('ProgressCircleDsgn Render failed', e);
            return <div>ProgressCircle Failed to Render {String(e)}</div>;
        }
    },
});
